import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';

export function resolvePrinterPrintProgressPercent(progressMap, printerUuid) {
    const value = progressMap?.[printerUuid];
    if (value == null) {
        return 0;
    }
    return Math.min(100, Math.max(0, Number(value) || 0));
}

function progressFillSx(theme, color, isActive) {
    const palette = theme.palette[color] || theme.palette.success;

    return {
        height: '100%',
        borderRadius: 1,
        backgroundColor: palette.main,
        transition: 'width 0.45s ease',
        ...(isActive ? {
            position: 'relative',
            overflow: 'hidden',
            backgroundImage: `linear-gradient(
                90deg,
                ${palette.main} 0%,
                ${palette.light} 45%,
                ${palette.main} 90%
            )`,
            backgroundSize: '200% 100%',
            animation: 'printerProgressFlow 2.8s ease-in-out infinite',
            '&::after': {
                content: '""',
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.28), transparent)',
                animation: 'printerProgressShimmer 2.2s ease-in-out infinite',
            },
        } : {}),
    };
}

export default function PrinterPrintProgressBar({
    percent = 0,
    label = 'Progresso da impressão',
    color = 'success',
    sx,
}) {
    const theme = useTheme();
    const value = Math.min(100, Math.max(0, Number(percent) || 0));
    const isActive = value > 0;

    return (
        <Box
            sx={{
                mb: 1.5,
                ...sx,
                '@keyframes printerProgressFlow': {
                    '0%': { backgroundPosition: '100% 0' },
                    '100%': { backgroundPosition: '-100% 0' },
                },
                '@keyframes printerProgressShimmer': {
                    '0%': { transform: 'translateX(-120%)' },
                    '100%': { transform: 'translateX(120%)' },
                },
                '@media (prefers-reduced-motion: reduce)': {
                    '& .printer-progress-fill': {
                        animation: 'none',
                        '&::after': {
                            animation: 'none',
                        },
                    },
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 0.5,
                }}
            >
                <Typography variant="caption" color="text.secondary">
                    {label}
                </Typography>
                <Typography variant="caption" color="text.secondary" fontWeight={600}>
                    {Math.round(value)}%
                </Typography>
            </Box>
            <Box
                role="progressbar"
                aria-valuenow={Math.round(value)}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={label}
                sx={{
                    height: 8,
                    borderRadius: 1,
                    bgcolor: 'action.hover',
                    overflow: 'hidden',
                }}
            >
                <Box
                    className="printer-progress-fill"
                    sx={{
                        width: `${value}%`,
                        ...progressFillSx(theme, color, isActive),
                    }}
                />
            </Box>
        </Box>
    );
}
